<template>
    <div>
        <el-form size="small" :model="formData" :rules="rules" ref="areaFormRef" label-width="120px">

            <el-divider>区域信息</el-divider>
            <el-form-item label="左上角经度" prop="dwLeftTopLon">
                <el-input v-model.number="formData.dwLeftTopLon" readonly placeholder="请输入左上角经度"></el-input>
            </el-form-item>
            <el-form-item label="左上角纬度" prop="dwLeftTopLat">
                <el-input v-model.number="formData.dwLeftTopLat" readonly placeholder="请输入左上角纬度"></el-input>
            </el-form-item>
            <el-form-item label="右下角经度" prop="dwRightBotLon">
                <el-input v-model.number="formData.dwRightBotLon" readonly placeholder="请输入右下角经度"></el-input>
            </el-form-item>
            <el-form-item label="右下角纬度" prop="dwRightBotLat">
                <el-input v-model.number="formData.dwRightBotLat" readonly placeholder="请输入右下角纬度"></el-input>
            </el-form-item>
            <el-form-item label="坡度" prop="slope">
                <el-input v-model.number="formData.slope" type="number" placeholder="请输入坡度"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" size="mini" @click="drawAreaOnMap">通过地图绘制区域</el-button>
            </el-form-item>
            <el-form-item>
                <el-button size="small" @click="cancelEdit">取消区域编辑</el-button>
                <el-button type="primary" size="small" @click="saveArea">
                    {{ isAreaEdit ? '更新区域' : '保存区域' }}
                </el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
export default {
    name: 'AreaEdit',
    props: {
        map: {
            type: Object,
            default: () => { },
        },
    },
    data() {
        return {
            isAreaEdit: false,
            formData: {
                areaID: 0,
                dwLeftTopLon: 0,
                dwLeftTopLat: 0,
                dwRightBotLon: 0,
                dwRightBotLat: 0,
                slope: 0,
            },
            rules: {

                'dwLeftTopLon': [
                    { required: true, message: '请输入左上角经度', trigger: 'blur' },
                    { type: 'number', message: '经度必须为数字', trigger: 'blur' },
                    // { min: -180, max: 180, message: '经度范围必须在-180到180之间', trigger: 'blur' }
                ],
                'dwLeftTopLat': [
                    { required: true, message: '请输入左上角纬度', trigger: 'blur' },
                    { type: 'number', message: '纬度必须为数字', trigger: 'blur' },
                    // { min: -90, max: 90, message: '纬度范围必须在-90到90之间', trigger: 'blur' }
                ],
                'dwRightBotLon': [
                    { required: true, message: '请输入右下角经度', trigger: 'blur' },
                    { type: 'number', message: '经度必须为数字', trigger: 'blur' },
                    // { min: -180, max: 180, message: '经度范围必须在-180到180之间', trigger: 'blur' }
                ],
                'dwRightBotLat': [
                    { required: true, message: '请输入右下角纬度', trigger: 'blur' },
                    { type: 'number', message: '纬度必须为数字', trigger: 'blur' },
                    // { min: -90, max: 90, message: '纬度范围必须在-90到90之间', trigger: 'blur' }
                ],
                slope: [
                    { required: true, message: '请输入坡度', trigger: 'blur' },
                    { type: 'number', message: '坡度必须为数字', trigger: 'blur' },
                ]
            }
        }
    },
    methods: {
        saveArea() {
            //把数据传递出去，
            this.$emit('save', this.formData);
        },
        edit(area) {
            this.isAreaEdit = true;
            this.formData = {
                areaID: area.areaID,
                dwLeftTopLon: area.dwLeftTopLon,
                dwLeftTopLat: area.dwLeftTopLat,
                dwRightBotLon: area.dwRightBotLon,
                dwRightBotLat: area.dwRightBotLat,
                slope: area.slope,
            }
             if (this.map) {
                this.map.clearOverlay();
                const coordinates = [
                    { lng: area.dwLeftTopLon, lat: area.dwLeftTopLat }, // 左上角
                    { lng: area.dwRightBotLon, lat: area.dwLeftTopLat }, // 右上角
                    { lng: area.dwRightBotLon, lat: area.dwRightBotLat }, // 右下角
                    { lng: area.dwLeftTopLon, lat: area.dwRightBotLat } // 左下角
                ];

                // 绘制矩形区域（使用addPolygon方法）
                this.map.addPolygon(
                    area.areaID, // 区域ID
                    "area_" + area.areaID, // 区域名称
                    coordinates, // 坐标数组
                    2, // 线条宽度
                    '#1890ff', // 线条颜色
                    '#1890ff88' // 填充颜色（带透明度）
                );
            }
        },
        add() {
            this.isAreaEdit = false;
            //初始化
            this.formData = {
                areaID: 0,
                dwLeftTopLon: 0,
                dwLeftTopLat: 0,
                dwRightBotLon: 0,
                dwRightBotLat: 0,
                slope: 0,
            }
           
        },
        // 通过地图绘制区域
        drawAreaOnMap() {
            if (this.map) {
                // 清除之前的绘制
                this.map.clearOverlay();
                // 开始绘制矩形
                this.map.drawRectangle(2, '#CD3700', '#B3EE3A', (left_lng, left_lat, right_lng, right_lat) => {
                    // 矩形绘制完成后的回调
                    this.formData.dwLeftTopLon = left_lng;
                    this.formData.dwLeftTopLat = left_lat;
                    this.formData.dwRightBotLon = right_lng;
                    this.formData.dwRightBotLat = right_lat;

                    this.$message.success('区域绘制完成，坐标已自动填充');

                });
                this.$message.info('请在地图上绘制矩形区域');
            } else {
                this.$message.error('地图加载未完成，请稍后再试');
            }
        },
        cancelEdit() {
            this.$refs.areaFormRef.resetFields();

            //    this.formData = {
            //     areaID: 0,
            //     dwLeftTopLon: 0,
            //     dwLeftTopLat: 0,
            //     dwRightBotLon: 0,
            //     dwRightBotLat: 0,
            //     slope: 0,
            // }
            this.$emit('cancelEdit');
        },
    }
}
</script>
<style scoped></style>